import { useCallback, useEffect, useState } from 'react';
import {
  ORG_DATE_SETTINGS_UPDATED_EVENT,
  useOrgDefaultDateRange,
} from '@saas-foundation/shared-frontend/dateRange';
import {
  getDefaultReportingPeriod,
  orgRcmSettingsToReportingPeriod,
} from '../../../utils/reportingPeriod';

/**
 * Dashboard reporting period: starts from org Settings default, allows per-session override.
 * Resets to org default when org date settings are saved in Settings.
 */
export function useDashboardReportingPeriod() {
  const { rcmSettings, defaultWindow, ready } = useOrgDefaultDateRange();
  const [period, setPeriod] = useState(getDefaultReportingPeriod);
  const [userOverride, setUserOverride] = useState(false);

  useEffect(() => {
    if (!ready || userOverride) return;
    setPeriod(orgRcmSettingsToReportingPeriod(rcmSettings, defaultWindow));
  }, [ready, rcmSettings, defaultWindow, userOverride]);

  useEffect(() => {
    const onOrgSettingsUpdated = () => setUserOverride(false);
    window.addEventListener(ORG_DATE_SETTINGS_UPDATED_EVENT, onOrgSettingsUpdated);
    return () => window.removeEventListener(ORG_DATE_SETTINGS_UPDATED_EVENT, onOrgSettingsUpdated);
  }, []);

  const onPeriodChange = useCallback((nextPeriod) => {
    setUserOverride(true);
    setPeriod(nextPeriod);
  }, []);

  return { period, onPeriodChange, orgDateReady: ready };
}
